import { useLazyQuery } from '@apollo/client/react';
import { SPOT_INFO_DISTRACTIONS } from '../../graphql/spots.queries';

export default function useGetSpotDistractions() {
    const [getSpotDistractions, { data, loading }] = useLazyQuery(SPOT_INFO_DISTRACTIONS);
    return { getSpotDistractions, data, loading };
}
